import { z } from "../wire/zod";

export const createStickyTypeResponseSchema = z.object({
  stickyType: z.object({
    id: z.string(),
    sessionId: z.string(),
    name: z.string(),
    color: z.tuple([z.number(), z.number(), z.number(), z.number()]),
    altColor: z
      .union([z.tuple([z.number(), z.number(), z.number(), z.number()]), z.null()])
      .optional(),
    originBoardType: z.enum([
      "team",
      "risk",
      "program",
      "solution",
      "solution_backlog",
      "backlog",
      "flex",
    ]),
    originFlexboardType: z.string().optional(),
    almType: z.union([z.string(), z.null()]).optional(),
    availableBoardTypes: z.array(
      z.enum(["team", "risk", "program", "solution", "solution_backlog", "backlog", "flex"]),
    ),
    availableFlexboardTypes: z.array(z.string()).optional(),
    templateId: z.string().optional(),
    functionality: z.enum(["workitem", "note", "risk", "dependency"]),
    stepEstimate: z.boolean().optional(),
    stepEstimateValues: z.array(z.object({ text: z.string(), value: z.number().int() })).optional(),
    index: z.number().int().describe("Sort order in the session's palette").optional(),
  }),
});
export const getStickyTypeResponseSchema = z.object({
  stickyType: z
    .object({
      id: z.string(),
      sessionId: z.string(),
      name: z.string(),
      color: z.tuple([z.number(), z.number(), z.number(), z.number()]),
      altColor: z
        .union([z.tuple([z.number(), z.number(), z.number(), z.number()]), z.null()])
        .optional(),
      originBoardType: z.enum([
        "team",
        "risk",
        "program",
        "solution",
        "solution_backlog",
        "backlog",
        "flex",
      ]),
      originFlexboardType: z.string().optional(),
      almType: z.union([z.string(), z.null()]).optional(),
      availableBoardTypes: z.array(
        z.enum(["team", "risk", "program", "solution", "solution_backlog", "backlog", "flex"]),
      ),
      availableFlexboardTypes: z.array(z.string()).optional(),
      templateId: z.string().optional(),
      functionality: z.enum(["workitem", "note", "risk", "dependency"]),
      stepEstimate: z.boolean().optional(),
      stepEstimateValues: z
        .array(z.object({ text: z.string(), value: z.number().int() }))
        .optional(),
      index: z.number().int().describe("Sort order in the session's palette").optional(),
    })
    .optional(),
});
export const getStickyTypesResponseSchema = z.object({
  stickyTypes: z.array(
    z.object({
      id: z.string(),
      sessionId: z.string(),
      name: z.string(),
      color: z.tuple([z.number(), z.number(), z.number(), z.number()]),
      altColor: z
        .union([z.tuple([z.number(), z.number(), z.number(), z.number()]), z.null()])
        .optional(),
      originBoardType: z.enum([
        "team",
        "risk",
        "program",
        "solution",
        "solution_backlog",
        "backlog",
        "flex",
      ]),
      originFlexboardType: z.string().optional(),
      almType: z.union([z.string(), z.null()]).optional(),
      availableBoardTypes: z.array(
        z.enum(["team", "risk", "program", "solution", "solution_backlog", "backlog", "flex"]),
      ),
      availableFlexboardTypes: z.array(z.string()).optional(),
      templateId: z.string().optional(),
      functionality: z.enum(["workitem", "note", "risk", "dependency"]),
      stepEstimate: z.boolean().optional(),
      stepEstimateValues: z
        .array(z.object({ text: z.string(), value: z.number().int() }))
        .optional(),
      index: z.number().int().describe("Sort order in the session's palette").optional(),
    }),
  ),
});
export const noDataSchema = z.record(z.string(), z.never());
export const stickyTypeCreatedEventSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  name: z.string(),
  color: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  altColor: z
    .union([z.tuple([z.number(), z.number(), z.number(), z.number()]), z.null()])
    .optional(),
  originBoardType: z.enum([
    "team",
    "risk",
    "program",
    "solution",
    "solution_backlog",
    "backlog",
    "flex",
  ]),
  originFlexboardType: z.string().optional(),
  almType: z.union([z.string(), z.null()]).optional(),
  availableBoardTypes: z.array(
    z.enum(["team", "risk", "program", "solution", "solution_backlog", "backlog", "flex"]),
  ),
  availableFlexboardTypes: z.array(z.string()).optional(),
  templateId: z.string().optional(),
  functionality: z.enum(["workitem", "note", "risk", "dependency"]),
  stepEstimate: z.boolean().optional(),
  stepEstimateValues: z.array(z.object({ text: z.string(), value: z.number().int() })).optional(),
  index: z.number().int().describe("Sort order in the session's palette").optional(),
});
export const stickyTypeDeletedEventSchema = z.string();
export const stickyTypeUpdatedEventSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  name: z.string(),
  color: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  altColor: z
    .union([z.tuple([z.number(), z.number(), z.number(), z.number()]), z.null()])
    .optional(),
  originBoardType: z.enum([
    "team",
    "risk",
    "program",
    "solution",
    "solution_backlog",
    "backlog",
    "flex",
  ]),
  originFlexboardType: z.string().optional(),
  almType: z.union([z.string(), z.null()]).optional(),
  availableBoardTypes: z.array(
    z.enum(["team", "risk", "program", "solution", "solution_backlog", "backlog", "flex"]),
  ),
  availableFlexboardTypes: z.array(z.string()).optional(),
  templateId: z.string().optional(),
  functionality: z.enum(["workitem", "note", "risk", "dependency"]),
  stepEstimate: z.boolean().optional(),
  stepEstimateValues: z.array(z.object({ text: z.string(), value: z.number().int() })).optional(),
  index: z.number().int().describe("Sort order in the session's palette").optional(),
});
